define('app/models/Field',['require','glu/model','glu/util'],function(require) {
	'use strict';

	var Model = require('glu/model');
	var _ = require('glu/util');

	//TODO: Move aggregationOptions here.

	return Model.extend({

		fieldsToShowFullName: ['Date-time', 'Day', 'Week', 'Month', 'Year-Month', 'Year', 'Time', 'Hour', 'Minute'],

		name: function() {
			return this.get('name');
		},

		description: function() {
			return this.get('description');
		},

		displayName: function() {
			var name = this.get('name');
			if (this.fieldsToShowFullName.indexOf(name) > -1) {
				name = this.qualifiedName();
			}
			return this.get('asName') || name;
		},

		qualifiedName: function() {
			return this.get('group') + ': ' + this.get('name');
		},

		isMeasure: function() {
			return !!this.get('isMeasure');
		},

		isDimension: function() {
			return !this.isMeasure();
		},

		defaultAggregation: function() {
			return this.isMeasure() ? 'SUM' : 'COUNTD';
		},

		dataType: function() {
			return this.get('type');
		},

		table: function() {
			return this.get('group');
		},

		domainId: function() {
			return this.get('domainId');
		},

		canBeGrouped: function() {
			// This function exists because originally only dimensions
			// could be grouped. Leaving it in until we settle the defintions
			// dimension, measure, and fact.
			return true;
		},

		getEnumeration: function() {
			var enm = this.get('enumeration');
			return _.isEmpty(enm) ? null : enm;
		},

		getDisplayFormat: function() {
			return this.get('displayFormat');
		}

	});

});

